import { fromJS } from 'immutable';
import { createSelector } from 'reselect';
import { GetDocuments } from '../../api/Documents';

// ACTIONS TYPES
export const FETCH_DOCUMENTS_SUCCESS = 'customer-portal/documents/FETCH_DOCUMENTS_SUCCESS';
export const FETCH_DOCUMENTS_FAILURE = 'customer-portal/documents/FETCH_DOCUMENTS_FAILURE';
export const FETCHING_DOCUMENTS = 'customer-portal/documents/FETCHING_DOCUMENTS';

// ACTION CREATORS
export const fetchDocumentsSuccess = documents => ({
  type: FETCH_DOCUMENTS_SUCCESS,
  payload: documents,
});

export const fetchDocumentsFailure = err => ({
  type: FETCH_DOCUMENTS_FAILURE,
  payload: err,
});

export const fetchingDocuments = () => ({
  type: FETCHING_DOCUMENTS,
});

// THUNKS
export const fetchDocuments = (contractId, proposalId, sowId) => async dispatch => {
  dispatch(fetchingDocuments());
  try {
    const { data } = await GetDocuments(contractId, proposalId, sowId);
    dispatch(fetchDocumentsSuccess(data));
  } catch (error) {
    dispatch(fetchDocumentsFailure(error));
  }
};

export const shouldFetchDocuments = documentState => !documentState.get('loaded') && !documentState.get('loading');

export const fetchDocumentsIfNeeded = (contractId, proposalId, sowId) => dispatch => {
  return dispatch(fetchDocuments(contractId, proposalId, sowId));
};

// SELECTORS
const documentsSelector = state => state.documents;

export const getAllDocuments = createSelector([documentsSelector], documents => documents.get('docs'));

export const getDocumentsLoading = createSelector([documentsSelector], documents => documents.get('loading'));

export const getDocumentsError = createSelector([documentsSelector], documents => documents.get('error'));

// REDUCER
export const initialState = fromJS({
  loaded: false,
  loading: false,
  error: null,
  docs: [],
});

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DOCUMENTS_SUCCESS:
      return state.set('loaded', true).set('loading', false).set('error', null).set('docs', action.payload);
    case FETCH_DOCUMENTS_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    case FETCHING_DOCUMENTS:
      return state.set('loading', true);
    default:
      return state;
  }
};
